import { useQuery } from '@tanstack/react-query';

import { fetchMerchants } from 'apis/restaurant-api/merchant-admin/merchant/api';

export const useMerchants = () => {
  const {
    data: merchants,
    isLoading: isLoadingMerchants,
    error: merchantsError,
  } = useQuery(['/v1/merchant-admin/merchants'], () => fetchMerchants(), {
    // Explicitly refetching on focus is necessary because we can't integrate the Juro signature into merchant-admin.
    // Once the contract is signed in Juro a new merchant is created and the user should be able to see it when coming back to the app.
    refetchOnWindowFocus: true,
    refetchOnMount: false,
  });

  return { merchants, isLoadingMerchants, merchantsError };
};
